import { useConfigStore, useNotifyStore, useUserStore } from '~/store'

export default defineNuxtRouteMiddleware(async (to) => { // (to, from)
    const userStore = useUserStore()
    const configStore = useConfigStore()
    const currentUser = userStore.currentUser
    // console.log('currentUser', currentUser)

    let isAuthenticated = !!currentUser && (typeof currentUser.k === 'string' || typeof currentUser.k === 'number')

    if (!isAuthenticated) {
        const res = await userStore.fetchUser()
        isAuthenticated = !!res?.data?.k
    }

    if (!isAuthenticated) {
        // Open the login modal, remembering where to send the user back
        // (avoid looping/re-notifying if already on the login page)
        if (to.path !== '/' && to.path !== '/connexion') {
            configStore.setGlobalLoading(false)

            useNotifyStore().showMessage({
                title: 'Utilisateur non authentifié',
                text: `Vous ne pouvez pas accéder à cette page.`,
                color: 'error',
                icon: 'mdi-alert-circle',
                timer: 5,
            })

            userStore.setUrlUserIntent(to.fullPath)
            return navigateTo('/connexion')
        }
        return
    }

    // Authenticated (either already, or just now): honor any pending post-login redirect
    if (userStore.urlUserIntent) {
        const toPath = userStore.urlUserIntent
        userStore.setUrlUserIntent(null)
        return navigateTo({ path: toPath })
    }
})
